import { ContactAutofill, } from '@wix/ambassador-forms-v4-form/types';
import { FIELD_TYPES } from '@wix/form-fields';
const AUTOFILL_FIELDS = [
    { fieldType: FIELD_TYPES.CONTACTS_EMAIL, key: 'email' },
    { fieldType: FIELD_TYPES.CONTACTS_FIRST_NAME, key: 'firstName' },
    { fieldType: FIELD_TYPES.CONTACTS_LAST_NAME, key: 'lastName' },
    { fieldType: FIELD_TYPES.CONTACTS_PHONE, key: 'phone' },
];
export function getAutofillValues(form, config) {
    const userData = config?.userData;
    if (!userData || form?.autoFillContact !== ContactAutofill.MEMBER_DATA) {
        return {};
    }
    const fields = form?.fields ?? [];
    const result = {};
    for (const { fieldType, key } of AUTOFILL_FIELDS) {
        const value = userData[key]?.trim();
        if (!value) {
            continue;
        }
        const target = fields.find((field) => field.view?.fieldType === fieldType)?.target;
        if (target) {
            result[target] = value;
        }
    }
    return result;
}
//# sourceMappingURL=autofill.js.map